import { Lightbulb } from "lucide-react";
import { contactMailto } from "@/lib/contact";

/** "Don't see the prize you want? Ask us." Shown wherever prizes are set up. */
export default function PrizeFeatureRequest() {
  return (
    <p className="flex items-start gap-2 text-sm text-muted-foreground">
      <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
      <span>
        Don't see the kind of prize you have in mind?{" "}
        <a href={contactMailto("Feature Request")} className="font-medium text-primary hover:underline">Email us a feature request</a>
        {" "}and we'll look at adding it.
      </span>
    </p>
  );
}
